import {FC} from 'react';
import {hasValue, IRecordStructurePromptPartsDoc} from '@kcast-fe/core';
import {Box, Flex, Grid} from '@chakra-ui/react';
import {Svg, Badge, useScreenSize} from 'ui-kit';
import {docsUtils} from 'core';

import {EmptyValue} from '../EmptyValue';

interface IProps {
  docs: IRecordStructurePromptPartsDoc[] | null;
}

const COLUMNS: Array<keyof IRecordStructurePromptPartsDoc> = [
  'file',
  'chunk',
  'hybrid',
  'rerank',
  'kept'
];

const MOBILE_COLUMNS: Array<keyof IRecordStructurePromptPartsDoc> = ['file', 'kept'];

export const CandidatesTable: FC<IProps> = ({docs}) => {
  const {isLessThan768} = useScreenSize();

  if (!hasValue(docs) || docs.length === 0) {
    return <EmptyValue />;
  }

  const gridTemplateColumns = isLessThan768 ? '1fr 50px' : '1fr repeat(3, 70px) 50px';

  return (
    <Box overflow={'hidden'} px={'8px'}>
      <Grid fontSize={'14px'} gridTemplateColumns={gridTemplateColumns}>
        {(isLessThan768 ? MOBILE_COLUMNS : COLUMNS).map((c) => (
          <Box
            key={c}
            pb={'6px'}
            fontSize={'12px'}
            fontWeight={'semibold'}
            textTransform={'uppercase'}
            color={'{colors.textTertiary}'}
          >
            {c}
          </Box>
        ))}
      </Grid>

      {docs.map((d, i) => (
        <Grid
          key={i}
          py={'8px'}
          fontSize={'14px'}
          gridTemplateColumns={gridTemplateColumns}
          borderTop={'thin solid'}
          borderColor={'{colors.borderDefault}'}
          alignItems={'center'}
        >
          <Flex gap={'4px'} alignItems={'center'}>
            <Svg name={docsUtils.getSvgIconByExtension(d.file)} size={'s20'} />
            <Box className={'cut-text'}>{d.file}</Box>
          </Flex>
          {!isLessThan768 && (
            <>
              <Box>{d.chunk}</Box>
              <Box>{d.hybrid}</Box>
              <Box>{d.rerank}</Box>
            </>
          )}
          <Box>
            <Badge variant={d.kept ? 'success' : 'neutral'}>{d.kept ? 'Yes' : 'No'}</Badge>
          </Box>
        </Grid>
      ))}
    </Box>
  );
};
